import React, { useState } from "react";
import Icon from "../Shared/Icon";
import { KAVACH_COLORS } from "./KavachData";

const HOW_THIS_WORKS = [
  "Every ₹500 of net purchase on the KAVACH portal earns 1 reward point.",
  "Points post 48 hours after delivery confirmation and never expire within the financial year.",
  "Crossing a level unlocks its reward instantly. Claim it any time before 31 March.",
];

const KAVACH_BENEFITS = [
  "Kavach Plus carries a 2x point multiplier on every unit sold.",
  "Members get priority stock allocation and free same-day delivery above ₹5,000.",
  "CureCoins convert 1:1 to credit against your next invoice.",
];

const KavachInsights = ({
  insights,
  loading = false,
  error = null,
  onRetry,
  onViewDetails,
}) => {
  const [howOpen, setHowOpen] = useState(true);
  const [benefitsOpen, setBenefitsOpen] = useState(true);

  return (
    <div className="kavach-insights-card" style={styles.card}>
      <div style={styles.headingRow}>
        <Icon name="bulb" size={18} color={KAVACH_COLORS.gold} />
        <span style={styles.heading}>Helpful Insights</span>
      </div>

      {loading && <span style={styles.stateText}>Loading insights…</span>}

      {!loading && error && (
        <div style={styles.errorState}>
          <span style={styles.stateText}>
            Couldn't load your sales insights.
          </span>
          <button
            className="kavach-pressable"
            style={styles.retryBtn}
            onClick={onRetry}>
            Retry
          </button>
        </div>
      )}

      {!loading && !error && insights && (
        <>
          {insights.headline && (
            <>
              <div style={styles.almostBadge}>
                <Icon name="bolt" size={12} color={KAVACH_COLORS.gold} />
                <span>{insights.progressPercent}% ALMOST THERE</span>
              </div>
              <div style={styles.bigLine}>{insights.headline}</div>
              {(insights.subtext || insights.pointsToGo != null) && (
                <div style={styles.subLine}>
                  {insights.subtext ||
                    `Only ${insights.pointsToGo} points to go`}
                </div>
              )}
              <div style={styles.barTrack}>
                <div
                  style={{
                    ...styles.barFill,
                    width: `${insights.progressPercent}%`,
                  }}
                />
              </div>
            </>
          )}

          {insights.planBreakdown.length > 0 && (
            <div style={styles.sourceList}>
              {insights.planBreakdown.map((p) => (
                <div key={p.label} style={styles.sourceRow}>
                  <span style={styles.sourceLabel}>{p.label}</span>
                  <span style={styles.sourceValue}>
                    {p.salesNeeded} more sales
                  </span>
                </div>
              ))}
            </div>
          )}

          <div style={styles.salesCard}>
            <div style={styles.salesHeadRow}>
              <div style={styles.salesHeading}>KAVACH SALES</div>
              {/* {onViewDetails && (
                <button
                  className="kavach-pressable"
                  style={styles.viewDetailsBtn}
                  onClick={onViewDetails}>
                  View Details
                  <Icon name="chevronRight" size={12} color="#B9C4DE" />
                </button>
              )} */}
            </div>
            <div style={styles.salesGrid}>
              <div style={styles.salesTile}>
                <div style={styles.salesValue}>{insights.salesToday}</div>
                <div style={styles.salesLabel}>Today</div>
              </div>
              <div style={styles.salesTile}>
                <div style={styles.salesValue}>{insights.salesThisWeek}</div>
                <div style={styles.salesLabel}>This week</div>
              </div>
              <div style={styles.salesTile}>
                <div style={styles.salesValue}>{insights.salesThisMonth}</div>
                <div style={styles.salesLabel}>This month</div>
              </div>
            </div>
          </div>

          {insights.topPlan && (
            <div style={styles.row}>
              <div style={styles.rocketBadge}>
                <Icon name="rocket" size={13} color="#fff" />
              </div>
              <span style={styles.pushText}>
                <strong>{insights.topPlan.label}</strong> has driven{" "}
                {insights.topPlan.sharePercent}% of your points — one more push!
              </span>
            </div>
          )}
        </>
      )}

      <div style={styles.divider} />

      <button
        className="kavach-pressable"
        style={styles.accordionHead}
        onClick={() => setHowOpen((v) => !v)}>
        <span>How this works?</span>
        <Icon
          name="chevronDown"
          size={16}
          color="#fff"
          style={{
            transform: howOpen ? "rotate(180deg)" : "none",
            transition: "transform 200ms",
          }}
        />
      </button>
      {howOpen && (
        <div style={styles.accordionBody}>
          {HOW_THIS_WORKS.map((line) => (
            <p key={line} style={styles.accordionLine}>
              {line}
            </p>
          ))}
        </div>
      )}

      <div style={styles.divider} />

      <button
        className="kavach-pressable"
        style={styles.accordionHead}
        onClick={() => setBenefitsOpen((v) => !v)}>
        <span>Kavach benefits?</span>
        <Icon
          name="chevronDown"
          size={16}
          color="#fff"
          style={{
            transform: benefitsOpen ? "rotate(180deg)" : "none",
            transition: "transform 200ms",
          }}
        />
      </button>
      {benefitsOpen && (
        <div style={styles.accordionBody}>
          {KAVACH_BENEFITS.map((line) => (
            <p key={line} style={styles.accordionLine}>
              {line}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  card: {
    background: `linear-gradient(160deg, ${KAVACH_COLORS.purpleDark} 0%, #16283A 100%)`,
    borderRadius: 20,
    padding: "22px 20px 20px",
    color: "#fff",
    boxShadow: "0 14px 30px rgba(75,68,149,0.3)",
  },
  headingRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 16,
  },
  heading: { fontSize: 16, fontWeight: 700 },
  stateText: { fontSize: 12.5, color: "#9AA6BC" },
  errorState: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    alignItems: "flex-start",
    marginBottom: 16,
  },
  retryBtn: {
    border: "none",
    borderRadius: 10,
    padding: "8px 16px",
    background: KAVACH_COLORS.purple,
    color: "#FFFFFF",
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer",
  },
  row: { display: "flex", alignItems: "flex-start", gap: 10, marginBottom: 14 },
  almostBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    background: "rgba(255,215,0,0.14)",
    color: KAVACH_COLORS.gold,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 0.6,
    padding: "5px 10px",
    borderRadius: 20,
    marginBottom: 10,
  },
  bigLine: { fontSize: 17, fontWeight: 700, lineHeight: 1.3 },
  subLine: { fontSize: 12.5, color: "#B9C4DE", marginTop: 4, marginBottom: 10 },
  barTrack: {
    height: 8,
    borderRadius: 8,
    background: "rgba(255,255,255,0.12)",
    overflow: "hidden",
    marginBottom: 18,
  },
  barFill: {
    height: "100%",
    borderRadius: 8,
    background: `linear-gradient(90deg, ${KAVACH_COLORS.gold}, #FFE9A0)`,
    transition: "width 900ms cubic-bezier(.22,1,.36,1)",
  },
  sourceList: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    marginBottom: 18,
  },
  sourceRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: 12,
    padding: "11px 14px",
  },
  sourceLabel: { fontSize: 13, fontWeight: 600, color: "#E4E9F5" },
  sourceValue: { fontSize: 12.5, color: "#B9C4DE" },
  salesCard: {
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: 14,
    padding: "14px 14px 12px",
    marginBottom: 18,
  },
  salesHeadRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  salesHeading: {
    fontSize: 10.5,
    fontWeight: 700,
    letterSpacing: 1,
    color: "#8C9BC2",
  },
  viewDetailsBtn: {
    display: "flex",
    alignItems: "center",
    gap: 3,
    border: "none",
    background: "transparent",
    color: "#B9C4DE",
    fontSize: 11,
    fontWeight: 600,
    cursor: "pointer",
    padding: 0,
  },
  salesGrid: { display: "flex", justifyContent: "space-between" },
  salesTile: { textAlign: "center", flex: 1 },
  salesValue: { fontSize: 20, fontWeight: 700 },
  salesLabel: { fontSize: 11, color: "#B9C4DE", marginTop: 2 },
  rocketBadge: {
    width: 22,
    height: 22,
    minWidth: 22,
    borderRadius: "50%",
    background: KAVACH_COLORS.purple,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 1,
  },
  pushText: { fontSize: 12.5, color: "#DCE3F0", lineHeight: 1.4 },
  tileRow: { display: "flex", gap: 10, marginBottom: 18 },
  tile: {
    flex: 1,
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: 14,
    padding: "14px 14px 12px",
  },
  tileGold: { border: `1px solid rgba(255,215,0,0.3)` },
  tileValue: { fontSize: 17, fontWeight: 700 },
  tileLabel: { fontSize: 11, color: "#B9C4DE", marginTop: 2 },
  divider: { height: 1, background: "rgba(255,255,255,0.12)", margin: "4px 0" },
  accordionHead: {
    width: "100%",
    border: "none",
    background: "transparent",
    color: "#fff",
    fontSize: 14,
    fontWeight: 700,
    padding: "14px 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
  },
  accordionBody: { paddingBottom: 8 },
  accordionLine: {
    fontSize: 12.5,
    color: "#C7CEE0",
    lineHeight: 1.6,
    margin: "0 0 10px",
  },
};

export default KavachInsights;
